module.exports = "/images/speaker.png?a90f0f0a1a8da02827f74ba4e60a7ced";